import React, { useMemo } from 'react';
import { TBaseTag, TBaseTagContext } from '../types';
import { isArray, isPlainObject, isString } from 'lodash';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { TTag } from './types';
import { validate } from '@krugom/validator';

const checkGroup = (child: TBaseTag, group?: string) => {
  if ((child.group && child.group === group) || (!child.group && !group)) return true;
  return false
}

const filteredChildren = (context: Partial<TBaseTagContext>, tagProps: TTag) => {
  const templateChildren = context.template?.children;
  if (isString(templateChildren)) return templateChildren;
  if (isArray(templateChildren))
    return templateChildren.filter(item =>
      isString(item)
        ? true
        : isPlainObject(item)
          ? checkGroup(item as TBaseTag, tagProps.group)
          : false
    );
  if (isPlainObject(templateChildren))
    return (checkGroup(templateChildren as TBaseTag, tagProps.group))
      ? templateChildren
      : undefined;
  return undefined;
};

export const CustomChildren: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const validationScheme = useMemo(
    () => ({
      type: 'object',
      properties: {
        group: {
          type: 'string',
        },
      },
    }),
    []
  );

  const result = useMemo(() => validate(tagProps, validationScheme), [tagProps, validationScheme]);

  const children = useMemo(() => {
    if (!result.isValid) return;
    return filteredChildren(context, tagProps);
  }, [context, result.isValid]);

  if (!result.isValid) {
    console.error(
      'Тэг: $Children;',
      `Путь: ${context.path?.join('.') || 'Не указан'};`,
      result.errors
    );
    return null;
  }

  return <UniversalChildren context={context}>{children}</UniversalChildren>;
});

CustomChildren.displayName = 'CustomChildren';
